import List from './components/List';

const AgentNews = () => {
    return <List />;
};

export default AgentNews;
